export default {"src":"/_next/static/media/farcaster.4020c9ab.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};